import { Assert } from '@team/assert';
import { Props } from './types';
import { RegisteredInteractiveHtmlElements } from './enums';

export const isInteractive = <T>(props: Props<T>) => {
  if (props.disabled) {
    return false;
  }

  if (
    [props.href, props.onClick, props.onClickCapture].some(Assert.isDefined)
  ) {
    return true;
  }

  return Object.values(RegisteredInteractiveHtmlElements).some(
    (registeredElementType) => registeredElementType === props.Component
  );
};

export const prepareProps = <T>({
  Component,
  href,
  disabled,
  onClick,
  onClickCapture,
}: Props<T>): Props<T> => {
  if (Assert.isDefined(Component)) {
    return { Component };
  }

  if (Assert.isDefined(href)) {
    return { Component: 'a', 'aria-disabled': disabled };
  }

  if ([onClick, onClickCapture].some(Assert.isDefined)) {
    return {
      Component: 'div',
      role: 'button',
      tabIndex: disabled ? undefined : 0,
      'aria-disabled': disabled,
    };
  }

  return { Component: 'div' };
};
